const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The colleague's id in `?person=`, when it is one: Search & jump opens Recognize this way (APP-022). */
export function personParam(params: URLSearchParams): string | null {
  const id = params.get('person');
  return id !== null && UUID.test(id) ? id : null;
}
